import { render, staticRenderFns } from "./MenuItemScrolled.vue?vue&type=template&id=338714f8&scoped=true&"
import script from "./MenuItemScrolled.vue?vue&type=script&lang=js&"
export * from "./MenuItemScrolled.vue?vue&type=script&lang=js&"
import style0 from "./MenuItemScrolled.vue?vue&type=style&index=0&id=338714f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338714f8",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/MenuItemScrolled.vue
// module id = 137
// module chunks = 0